import React, { useState, useEffect } from 'react';
import Cards from './Cards';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import "../assets/css/style.css"
import {DataResponsive} from '../Data/ProductsData';
import { BackendURL } from '../utils/BackendURL';
import axios from 'axios';

export default function ProductSlider(props) {
  const [productcards, setproductcards] = useState([]);
  const findProductsByCategory = async (searchCategory) => {
    try {
      const response = await axios.get(`${BackendURL}/search-category/${searchCategory}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching data:', error);
      return [];
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const fetchedCards = await findProductsByCategory(props.category);
        console.log(fetchedCards)
        const cards = fetchedCards.map((item, index) => (
          <Cards
            key={index}
            index={`${props.category}-Cardno.${index}`}
            name={item.ItemName}
            category={props.category}
            imgname={item.ItemName}
            price={item.SalePrice}
            description={item.description}
          />
        ));
        setproductcards(cards);
      } catch (error) {
        console.error('Error in fetchData:', error);
      }
    }
    fetchData();
  }, [props.category]);

  return (
    <div className="PApp">
      <h1 className='Category-title'>{props.category.toUpperCase()}:</h1>
      <Carousel showDots={true} className="PCarousel" responsive={DataResponsive}>
        {productcards}
      </Carousel>
    </div>
  );
}
